import { Box, ChakraProvider, Flex, VStack } from "@chakra-ui/react";
import theme from "theme/theme";
import LandingPage from "views/Home/LandingPage/LandingPage";
import Statistics from "views/Dashboard/Statistics";
import { Route, Switch } from "react-router-dom";
import AuthNavbar from "components/Navbars/AuthNavbar";
import Information from "views/Dashboard/Infos";

export default function Home() {
  return (
    <ChakraProvider theme={theme}>
      <Flex direction="column" minH="100vh" alignContent="center">

        <Switch>
          <Route exact path="/home" component={LandingPage} />
          <Route path="/home/public-access" component={PublicAccess} />
        </Switch>
      </Flex>
    </ChakraProvider>
  );
}

const PublicAccess = () => {
  return (
    <Box height="100vh">  {/* Ensure Box takes the full height of the screen */}
    <AuthNavbar></AuthNavbar>
      <Flex
        mt={50}
        align="flex-start"  // Align items at the top vertically (you can adjust this as needed)
        justify="center"    // Center content horizontally
        height="100%" 
        mx={{ base: 3, md: 100 }}      // Ensure Flex takes up full height of the parent (Box)
      >
        <VStack>
        <Information/>

        <Statistics />  {/* The Statistics component */}

        </VStack>
      </Flex>
    </Box>
  );
}
